
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
    name: 'SpinnerMobileButton',
})
export default class SpinnerMobileButton extends Vue {
    /** 是否正在请求 */
    @Prop({ type: Boolean, default: false }) public requesting!: boolean;
    /** 标题 */
    @Prop({ type: String }) public title?: string;

    public onClick() {
        this.$emit('click');
    }
}
